// Generated by ts-to-zod
import {z} from "zod";
import {mantineSizeTokenSchema} from "./spacing.zod";

export const mantineLoaderPropsSchema = z.object({
	type: z.string().optional(),
	size: mantineSizeTokenSchema.optional(),
});
